export const EDIT_ATTRIBUTE_MODAL = 'EDIT_ATTRIBUTE_MODAL';
export const EDIT_PASSWORD_MODAL = 'EDIT_PASSWORD_MODAL';
export const ADD_PAYMENT_METHOD_MODAL = 'ADD_PAYMENT_METHOD_MODAL';
export const CONFIRM_REMOVE_PAYMENT_MODAL = 'CONFIRM_REMOVE_PAYMENT_MODAL';
export const CONFIRMATION_MODAL = 'CONFIRMATION_MODAL';
export const CREATE_ORDER_MODAL = 'CREATE_ORDER_MODAL';
export const INVALID_ITEMS_MODAL = 'INVALID_ITEMS_MODAL';
export const LINE_ITEM_CONFIGURATION_MODAL = 'LINE_ITEM_CONFIGURATION_MODAL';
export const LOCATION_CLOSED_MODAL = 'LOCATION_CLOSED_MODAL';
